import ThisModule from "./ProfilePhotoSection";

export default ThisModule;
